<template>
    <section id="theater" class="section_theater">
        <h2 class="section--title">Theater</h2>
        <div class="grid-container">
            <div class="grid-x align-center">
                <section class="section_theater--main cell small-12">
                    <h3 class="schedule--title"><strong>[シアター] イメージフォーラム</strong></h3>

                    <picture class="schedule--figure">
                        <source srcset="static/img/schedule_small_IF.jpg" media="(min-width: 540px)">
                        <img src="/netemosametemo/hamaguchi/static/img/schedule_small_IF_sp.jpg">
                    </picture>
                </section>

                <section class="section_theater--main cell small-12">
                    <h3 class="schedule--title"><strong>テアトル新宿オールナイト</strong></h3>

                    <ul class="schedule grid-x align-center align-middle">
                        <li class="schedule--main cell small-12 medium-auto">
                            <ul class="grid-x align-middle align-center">
                                <li class="cell small-12 large-7" style="background: #c0c0c0;">
                                    <img src="/netemosametemo/hamaguchi/static/img/schedule01_img.jpg" alt="schedule Shinjuku" style="opacity: 0.4;">
                                </li>
                                <li class="cell small-12 large-4">
                                    <!-- <p class="schedule--label_block">開演時間は後日、
                                        <br class="show-for-large">劇場HP等で告知します。
                                    </p> -->

                                    <p class="schedule--label_block" style="background-color: #d9d9d9;color: #8a8a8a;">
                                        開演時間：両日ともに22：00
                                        <br>トークショーゲスト
                                        <br>8/11（土） 黒沢清監督＋濱口竜介監督
                                        <br>8/18（土） 小野正嗣さん（作家）＋濱口竜介監督
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <!-- <li class="cell shrink">
                            <a href="https://ttcg.jp/theatre_shinjuku/topics/2018/07081854_3846.html" class="schedule_button" target="_blank" title="8/11, 8/18トークショー有り。">8/11, 8/18トークショー有り。<svg class="icon icon-cheveron-right"><use xlink:href="#icon-cheveron-right"></use></svg></a>
                        </li> -->
                    </ul>
                </section>

                <section class="section_theater--main cell small-12">
                    <h3 class="schedule--title_alt"><strong>キネカ大森</strong></h3>

                    <picture class="schedule--figure" style="background: #c0c0c0;">
                        <source srcset="static/img/schedule.jpg" media="(min-width: 540px)" style="opacity: 0.4;">
                        <img src="/netemosametemo/hamaguchi/static/img/schedule_small.jpg" style="opacity: 0.4;">
                    </picture>
                </section>

                <section class="section_theater--main cell small-12">
                    <h3 class="schedule--title_alt2"><strong>入場料金</strong></h3>
                    <ul class="schedule_article--holder grid-x align-center grid-padding-x" style="justify-content: start;">
                        <li class="cell small-12 large-6">
                            <article class="schedule_article">
                                <h4 class="schedule_article--title"><strong>[シアター] イメージフォーラム</strong></h4>
                                <ul class="schedule_article--main">
                                    <li class="schedule_article--main--item grid-x">
                                        <p class="cell auto">『PASSION』『THE DEPTHS』『不気味なものの肌に触れる／永遠に君を愛す』</p>
                                        <p class="cell shrink">1,300円</p>
                                    </li>
                                    <li class="schedule_article--main--item grid-x">
                                        <p class="cell auto">『ハッピーアワー』通し券</p>
                                        <p class="cell shrink">3,000円</p>
                                    </li>
                                    <li class="schedule_article--main--item grid-x">
                                        <p class="cell auto">『親密さ』通し券</p>
                                        <p class="cell shrink">2,000円</p>
                                    </li>
                                    <li class="schedule_article--main--item grid-x">
                                        <p class="cell auto">『寝ても覚めても』一般</p>
                                        <p class="cell shrink">1,800円</p>
                                    </li>
                                </ul>
                            </article>
                            <p class="schedule_article--info">
                                [シアター] イメージフォーラム
                                <br><a href="tel:03-5766-0114" title="03-5766-0114">03-5766-0114</a>
                                <br><a href="http://www.imageforum.co.jp/" title="ImageForum" target="_blank">www.imageforum.co.jp</a>
                            </p>
                        </li>
                        <li class="cell small-12 large-6">
                            <article class="schedule_article">
                                <h4 class="schedule_article--title"><strong>テアトル新宿<br>オールナイト</strong></h4>
                                <p class="schedule_article--main cell auto">
                                    2,500円均一
                                </p>
                            </article>
                            <p class="schedule_article--info">
                                テアトル新宿
                                <br><a href="tel:03-3352-1846" title="03-3352-1846">03-3352-1846</a>
                                <br><a href="https://ttcg.jp/theatre_shinjuku/" title="Theater Shinjuku" target="_blank">https://ttcg.jp/theatre_shinjuku/</a>
                            </p>
                        </li>
                        <li class="cell small-12 large-6">
                            <article class="schedule_article">
                                <h4 class="schedule_article--title_alt"><strong>キネカ大森</strong></h4>
                                <ul class="schedule_article--main">
                                    <li class="schedule_article--main--item grid-x">
                                        <p class="cell auto">１作品</p>
                                        <p class="cell shrink">1,300円均一</p>
                                    </li>
                                    <li class="schedule_article--main--item grid-x">
                                        <p class="cell auto">『ハッピーアワー』通し券</p>
                                        <p class="cell shrink">3,000円</p>
                                    </li>
                                    <li class="schedule_article--main--item grid-x">
                                        <p class="cell auto">『親密さ』通し券</p>
                                        <p class="cell shrink">2,000円</p>
                                    </li>
                                </ul>
                            </article>
                            <p class="schedule_article--info">
                                キネカ大森
                                <br><a href="tel:03-3762-6000" title="03-3762-6000">03-3762-6000</a>
                                <br><a href="https://ttcg.jp/cineka_omori/" title="Cineka Omori" target="_blank">https://ttcg.jp/cineka_omori/</a>
                            </p>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'theater',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Theater.vue